<template>
  <div class="service-plans">
    <service-header :signedIn="signedInUser !== null" />
    <section class="plans">
      <h2>
        <div>⽤途に合わせた料⾦プラン</div>
        <span class="text-service">まずはフリープランで<br class="d-block d-md-none">お試しください</span>
      </h2>
    </section>
    <section class="plan-overview-panels">
      <div class="plan-overview-panel free">
        <div class="first-from-here">まずはここから</div>
        <h3>フリープラン</h3>
        <h4>無料</h4>
        <div class="plan-overview-description">
          <div>気軽に</div>
          <div>チームコミュニケーション</div>
        </div>
        <ul>
          <li>5ユーザーライセンス</li>
          <li>5ルームのチャット</li>
          <li>
            <div>10MBまでの添付ファイル</div>
            <small class="disabled">※保存期間1ヶ月</small>
          </li>
          <li>5名のWEB会議室</li>
          <li>タスク管理機能</li>
        </ul>
        <div class="plan-overview-button-wrapper">
          <proa-service-button
            v-if="signedInUser === null"
            variant="primary square"
            text="無料アカウント作成"
            @click.native="$router.push({ name: 'signUp' })"
          />
        </div>
      </div>
      <div class="plan-overview-panel">
        <h3>スタンダード</h3>
        <h4>{{ 2980 | currencyJPY }} / {{ $t('common.month') }}</h4>
        <div class="plan-overview-description"/>
        <ul>
          <li>10ユーザーライセンス</li>
          <li>30ルームのチャット</li>
          <li>
            <div>50MBまでの添付ファイル</div>
            <small class="disabled">※保存期間6ヶ月</small>
          </li>
          <li>8名のWEB会議室</li>
          <li>カフェ（最大5名）</li>
          <li>タスク管理機能</li>
          <li>有料オプション追加</li>
        </ul>
      </div>
      <div class="plan-overview-panel">
        <h3>プロフェッショナル</h3>
        <h4>{{ 9800 | currencyJPY }} / {{ $t('common.month') }}</h4>
        <div class="plan-overview-description"/>
        <ul>
          <li>30ユーザーライセンス</li>
          <li>ルーム数無制限のチャット</li>
          <li>
            <div>200MBまでの添付ファイル</div>
            <small class="disabled">※保存期間1年</small>
          </li>
          <li>
            <div>3室のWEB会議室</div>
            <small class="disabled">※8名 / 16名 / 24名 各1室</small>
          </li>
          <li>カフェ（最大10名）</li>
          <li>タスク管理機能</li>
          <li>有料オプション追加</li>
        </ul>
      </div>
      <div class="plan-overview-panel">
        <h3 class="disabled">エンタープライズ</h3>
        <h4 class="disabled">現在準備中</h4>
        <div class="plan-overview-description"/>
        <ul class="disabled">
          <li>200ユーザーライセンス</li>
          <li>ルーム数無制限のチャット</li>
          <li>
            <div>200MBまでの添付ファイル</div>
            <small class="disabled">※保存期間5年</small>
          </li>
          <li>
            <div>6室のWEB会議室</div>
            <small class="disabled">※8名 / 16名 / 24名 各2室</small>
          </li>
          <li>カフェ（最大20名）</li>
          <li>タスク管理機能</li>
          <li>有料オプション追加</li>
          <li>ゲストユーザー管理機能</li>
          <li>ドメイン保護機能</li>
          <li>ブランディング機能</li>
          <li>監査ログ機能</li>
          <li>ヘルプサポート対応</li>
        </ul>
      </div>
    </section>
    <section class="plan-details-table">
      <table>
        <thead>
          <tr>
            <th></th>
            <th>フリープラン</th>
            <th class="blank"></th>
            <th>スタンダード</th>
            <th class="blank"></th>
            <th>プロフェッショナル</th>
            <th class="blank"></th>
            <th>エンタープライズ</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <th>WEB会議室</th>
            <td>1</td>
            <td class="blank"></td>
            <td>1</td>
            <td class="blank"></td>
            <td>3</td>
            <td class="blank"></td>
            <td>6</td>
          </tr>
          <tr>
            <th>最大人数</th>
            <td>5名</td>
            <td class="blank"></td>
            <td>8名</td>
            <td class="blank"></td>
            <td>8名 / 16名 / 24名</td>
            <td class="blank"></td>
            <td>8名 / 16名 / 24名</td>
          </tr>
          <tr>
            <th>カフェ</th>
            <td>なし</td>
            <td class="blank"></td>
            <td>最大5名</td>
            <td class="blank"></td>
            <td>最大10名</td>
            <td class="blank"></td>
            <td>最大20名</td>
          </tr>
          <tr>
            <th>チャットルーム数</th>
            <td>5</td>
            <td class="blank"></td>
            <td>30</td>
            <td class="blank"></td>
            <td>無制限</td>
            <td class="blank"></td>
            <td>無制限</td>
          </tr>
          <tr>
            <th>ユーザー数</th>
            <td>5</td>
            <td class="blank"></td>
            <td>10</td>
            <td class="blank"></td>
            <td>30</td>
            <td class="blank"></td>
            <td>200</td>
          </tr>
          <tr>
            <th>月額料金</th>
            <td>無料</td>
            <td class="blank"></td>
            <td>{{ 2980 | currencyJPY }} / {{ $t('common.month') }}</td>
            <td class="blank"></td>
            <td>{{ 9800 | currencyJPY }} / {{ $t('common.month') }}</td>
            <td class="blank"></td>
            <td>準備中</td>
          </tr>
          <tr>
            <th>
              <div>ファイル</div>
              <div>(保存期間)</div>
            </th>
            <td>
              <div>10MB</div>
              <div>(1ヶ月)</div>
            </td>
            <td class="blank"></td>
            <td>
              <div>50MB</div>
              <div>(6ヶ月)</div>
            </td>
            <td class="blank"></td>
            <td>
              <div>200MB</div>
              <div>(1年)</div>
            </td>
            <td class="blank"></td>
            <td>
              <div>200MB</div>
              <div>(5年)</div>
            </td>
          </tr>
          <tr>
            <th>有料オプション追加</th>
            <td>ー</td>
            <td class="blank"></td>
            <td>
              <span class="check"></span>
            </td>
            <td class="blank"></td>
            <td>
              <span class="check"></span>
            </td>
            <td class="blank"></td>
            <td>
              <span class="check"></span>
            </td>
          </tr>
          <tr>
            <th>ゲスト機能</th>
            <td>ー</td>
            <td class="blank"></td>
            <td>ー</td>
            <td class="blank"></td>
            <td>
              <span class="check"></span>
            </td>
            <td class="blank"></td>
            <td>
              <span class="check"></span>
            </td>
          </tr>
        </tbody>
      </table>
    </section>
    <service-footer
      :signedIn="signedInUser !== null"
      :route="$route.name"
    />
  </div>
</template>

<script>
import { mapGetters } from 'vuex'

import ServiceHeader from '@/components/molecules/service/ServiceHeader.vue'
import ServiceFooter from '@/components/molecules/service/ServiceFooter.vue'

export default {
  name: 'ServicePlans',
  components: {
    ServiceHeader,
    ServiceFooter
  },
  computed: {
    ...mapGetters({
      signedInUser: 'auth/signedInUser'
    })
  }
}
</script>

<style scoped lang="scss">
@import "@/styles/variables";
@import "@/styles/mediaquery";

.service-plans {
  width: 100%;

  section {
    overflow-x: auto;
  }

  .disabled {
    opacity: .5;
  }

  .plans {
    background-color: white;
    padding: 80px 20px 40px 20px;

    @include mq(md) {
      padding: 130px 20px 100px 20px;
    }

    h2 {
      text-align: center;
      font-size: 26px;
      font-weight: 600;
      line-height: 1.3;
      margin-bottom: 60px;

      @include mq(sm) {
        font-size: 32px;
      }
    }
  }

  .plan-overview-panels {
    padding: 60px 20px;
    background-color: $service-light-gray-background-color;
    display: flex;
    justify-content: flex-start;

    @include mq(md) {
      justify-content: center;
      padding: 60px 0;
    }

    .plan-overview-panel {
      background-color: white;
      border-radius: 4px;
      width: 260px;
      margin-right: 20px;
      padding: 30px;
      position: relative;
      display: flex;
      flex-direction: column;
      align-items: center;

      &:after {
        position: absolute;
        content: '';
        top: 0;
        left: 100%;
        height: 1px;
        width: 20px;
        background-color: transparent;
      }

      &:last-child {
        margin-right: 0;
      }

      &.free {
        border: 2px solid $service-primary-color;

        .first-from-here {
          position: absolute;
          word-break: keep-all;
          padding: 10px 20px;
          border-radius: 4px;
          top: -30px;
          left: 50%;
          transform: translate(-50%, 0);
          background-color: $service-primary-color;
          font-weight: 600;
          color: white;

          &:before{
            content: "";
            position: absolute;
            left: calc(50% - 8px);
            bottom: -10px;
            border-top: 10px solid $service-primary-color;
            border-right: 8px solid transparent;
            border-left: 8px solid transparent;
          }
        }
      }

      h3 {
        width: 260px;
        margin-top: 10px;
        margin-bottom: 0;
        font-size: 22px;
        font-weight: 600;
        text-align: center;
      }

      h4 {
        margin-top: 16px;
        margin-bottom: 0;
        font-size: 20px;
        font-weight: 600;
      }

      .plan-overview-description {
        margin: 30px 0;
        font-size: 16px;
        line-height: 1.5;
        color: $service-primary-color;
        text-align: center;
        height: 40px;
      }

      ul {
        flex-grow: 1;
        padding: 0;
        width: 100%;

        li {
          list-style: none;
          margin-bottom: 12px;
        }
      }

      .plan-overview-button-wrapper {
        width: 200px;

        button {
          width: 100%;
        }
      }
    }
  }

  .plan-details-table {
    padding: 60px 0;
    background-color: white;
    display: flex;
    justify-content: flex-start;

    @include mq(md) {
      justify-content: center;
      padding: 60px 0 200px 0;
    }

    table {
      border-collapse: separate;
      border-spacing: 0;

      thead th, tbody td {
        width: 210px;
        text-align: center;
      }

      th, td {
        white-space: nowrap;
      }

      thead {
        th {
          padding: 20px 10px;

          &.blank {
            padding: 5px;

            @include mq(md) {
              padding: 0;
            }
          }

          @include mq(md) {
            padding: 25px 0;
          }

          border-bottom: 2px solid #DCDCDC;
          color: black;

          &:nth-child(2) {
            border-top: 2px solid $service-primary-color;
            border-right: 2px solid $service-primary-color;
            border-left: 2px solid $service-primary-color;
            border-radius: 4px 4px 0 0;
          }

          &:last-child {
            color: rgba(0, 0, 0, .25);
          }
        }
      }

      tbody {
        th, td {
          padding: 32px 20px 0 20px;

          @include mq(md) {
            padding: 32px 0 0 0;
          }

          &.blank {
            padding: 0;
          }
        }

        td {
          padding: 32px 40px 0 40px;
          @include mq(md) {
            padding: 32px 0 0 0;
          }

          color: black;
          background-color: $service-light-gray-background-color;

          &:nth-child(2) {
            border-right: 2px solid $service-primary-color;
            border-left: 2px solid $service-primary-color;
          }

          &:last-child {
            color: rgba(0, 0, 0, .25);
          }

          .check {
            display: inline-block;
            position: relative;

            &:after {
              content: "";
              display: block;
              position: absolute;
              top: calc(50% - 10px);
              left: calc(50% - 10px);
              width: 24px;
              height: 14px;
              border-left: 3px solid $service-primary-color;
              border-bottom: 3px solid $service-primary-color;
              transform: rotate(-45deg);
            }
          }
        }

        tr:last-child {
          th, td {
            padding-bottom: 32px;
            border-radius: 0 0 4px 4px;
          }

          td:nth-child(2) {
            border-bottom: 2px solid $service-primary-color;
          }
        }
      }

      th.blank, td.blank {
        width: 10px;
        background-color: white;
      }
    }
  }

}
</style>
